import beforeAfterTableCompare from "./before_after_table_compare";
import deleteObject from "./delete_object";
import checkIfTwoObjectsEqual from "./check_if_two_objects_equal";

export const beforeAfterCompare = (dataType, inBeforeObject, inAfterObject) => {
   
    let dataSubTypeArr = [];
    let objectNameArr = [];
    let nonMatchInfo = {};
    let beforeObject = JSON.parse(JSON.stringify(inBeforeObject));
    let afterObject = JSON.parse(JSON.stringify(inAfterObject));
    if (dataType === "gameData"){
        objectNameArr = ["hand"];
    }
    objectNameArr.push("dateUpdated", "dateAdded", "__v", "_id");
    const newObjects = deleteObject(objectNameArr, beforeObject, afterObject);
    beforeObject = newObjects.beforeObject;
    afterObject = newObjects.afterObject;
    objectNameArr.splice(0);
        
    const objectSorter = GFG_Object =>
        Object.keys(GFG_Object)  
        .sort()
        .reduce((finalObject, key) => {  
        finalObject[key] = GFG_Object[key];  
        return finalObject;  
    }, {}); 

    beforeObject = objectSorter(beforeObject);
    afterObject = objectSorter(afterObject);
       
    //const isEqual = (obj1, obj2) => JSON.stringify(obj1) === JSON.stringify(obj2);
   
    const dataValid = checkIfTwoObjectsEqual(beforeObject, afterObject);
    if (dataValid === false){
        if (dataType === "gameData"){
            if (!checkIfTwoObjectsEqual(beforeObject.assetTable, afterObject.assetTable)){
                nonMatchInfo = beforeAfterTableCompare(beforeObject.assetTable, afterObject.assetTable, "object");
                dataSubTypeArr.push({data: "assetTable", nonMatchInfo: nonMatchInfo});
            }
            if (!checkIfTwoObjectsEqual(beforeObject.expenseTable, afterObject.expenseTable)){
                nonMatchInfo = beforeAfterTableCompare(beforeObject.expenseTable, afterObject.expenseTable, "object");
                dataSubTypeArr.push({data: "expenseTable", nonMatchInfo: nonMatchInfo});
            }
            if (!checkIfTwoObjectsEqual(beforeObject.loanTable, afterObject.loanTable)){
                nonMatchInfo = beforeAfterTableCompare(beforeObject.loanTable, afterObject.loanTable, "object");
                dataSubTypeArr.push({data: "loanTable", nonMatchInfo: nonMatchInfo});
            }
            if (!checkIfTwoObjectsEqual(beforeObject.skillSurvey, afterObject.skillSurvey)){
                nonMatchInfo = beforeAfterTableCompare(beforeObject.skillSurvey, afterObject.skillSurvey, "simple");
                dataSubTypeArr.push({data: "skillSurvey", nonMatchInfo: nonMatchInfo});
            }
            if (!checkIfTwoObjectsEqual(beforeObject.conditionsTable, afterObject.conditionsTable)){
                nonMatchInfo = beforeAfterTableCompare(beforeObject.conditionsTable, afterObject.conditionsTable, "object");
                dataSubTypeArr.push({data: "conditionsTable", nonMatchInfo: nonMatchInfo});
            }
            if (!checkIfTwoObjectsEqual(beforeObject.unlockedFeatures, afterObject.unlockedFeatures)){
                nonMatchInfo = beforeAfterTableCompare(beforeObject.unlockedFeatures, afterObject.unlockedFeatures, "object");
                dataSubTypeArr.push({data: "unlockedFeatures", nonMatchInfo: nonMatchInfo});
            }
            if (!checkIfTwoObjectsEqual(beforeObject.friendList, afterObject.friendList)){
                nonMatchInfo = beforeAfterTableCompare(beforeObject.friendList, afterObject.friendList, "object");
                dataSubTypeArr.push({data: "friendList", nonMatchInfo: nonMatchInfo});
            }
            if (!checkIfTwoObjectsEqual(beforeObject.jobInfo, afterObject.jobInfo)){
                nonMatchInfo = {indx: 0, beforeEntry: beforeObject.jobInfo, 
                    afterEntry: afterObject.jobInfo};
                dataSubTypeArr.push({data: "jobInfo", nonMatchInfo: nonMatchInfo});
            }
            if (!checkIfTwoObjectsEqual(beforeObject.carInfo, afterObject.carInfo)){
                nonMatchInfo = {indx: 0, beforeEntry: beforeObject.carInfo, 
                    afterEntry: afterObject.carInfo};
                dataSubTypeArr.push({data: "carInfo", nonMatchInfo: nonMatchInfo});
            }
            if (!checkIfTwoObjectsEqual(beforeObject.homeInfo, afterObject.homeInfo)){
                nonMatchInfo = {indx: 0, beforeEntry: beforeObject.homeInfo, 
                    afterEntry: afterObject.homeInfo};
                dataSubTypeArr.push({data: "homeInfo", nonMatchInfo: nonMatchInfo});
            }
            if (!checkIfTwoObjectsEqual(beforeObject.spendingHistory, afterObject.spendingHistory)){
                nonMatchInfo = {indx: 0, beforeEntry: beforeObject.spendingHistory, 
                    afterEntry: afterObject.spendingHistory};
                dataSubTypeArr.push({data: "spendingHistory", nonMatchInfo: nonMatchInfo});
            }
            if (!checkIfTwoObjectsEqual(beforeObject.moodPointHistory, afterObject.moodPointHistory)){
                nonMatchInfo = {indx: 0, beforeEntry: beforeObject.moodPointHistory, 
                    afterEntry: afterObject.moodPointHistory};
                dataSubTypeArr.push({data: "moodPointHistory", nonMatchInfo: nonMatchInfo});
            }
            if (!checkIfTwoObjectsEqual(beforeObject.iconTable, afterObject.iconTable)){
                nonMatchInfo = beforeAfterTableCompare(beforeObject.iconTable, afterObject.iconTable, "object");
                const compareObj = {beforeObject: beforeObject.iconTable, afterObject: afterObject.iconTable};
                dataSubTypeArr.push({date: "iconTable", nonMatchInfo: compareObj});
            }
            if (!checkIfTwoObjectsEqual(beforeObject.badgesEarned, afterObject.badgesEarned)){
                nonMatchInfo = beforeAfterTableCompare(beforeObject.badgesEarned, afterObject.badgesEarned, "object");
                dataSubTypeArr.push({data: "badgesEarned", nonMatchInfo: nonMatchInfo});
            }
            if (!checkIfTwoObjectsEqual(beforeObject.pendingJob, afterObject.pendingJob)){
                nonMatchInfo ={indx: 0, beforeEntry: beforeObject.pendingJob, 
                    afterEntry: afterObject.pendingJob};
                dataSubTypeArr.push({data: "pendingJob", nonMatchInfo: nonMatchInfo});
            }
            objectNameArr = ["assetTable", "expenseTable", "loanTable", "skillSurvey", "conditionsTable",
                "unlockedFeatures", "friendList", "jobInfo", "carInfo", "homeInfo", "spendingHistory",
                "moodPointHistory", "iconTable", "badgesEarned", "pendingJob"];
            const revisedObjects = deleteObject(objectNameArr, beforeObject, afterObject);
            const beforeGeneralObject = revisedObjects.beforeObject;
            const afterGeneralObject = revisedObjects.afterObject;
          
            if (!checkIfTwoObjectsEqual(beforeGeneralObject, afterGeneralObject)){
                nonMatchInfo = {indx: 0, beforeEntry: beforeGeneralObject, afterEntry: afterGeneralObject};
                dataSubTypeArr.push({data: "generalGameData", nonMatchInfo: nonMatchInfo});
            }
        }
    }
    if (dataType === "creditCardInfo"){
        if (!checkIfTwoObjectsEqual(beforeObject.periodCreditCharges, afterObject.periodCreditCharges)){
            nonMatchInfo = beforeAfterTableCompare(beforeObject.periodCreditCharges, afterObject.periodCreditCharges, 
                "object");
            dataSubTypeArr.push({data: "creditCard.PeriodCreditCharges", nonMatchInfo: nonMatchInfo});
        }
    }
    if (dataType === "gamePurchases"){
        if (!checkIfTwoObjectsEqual(beforeObject.purchaseTable, afterObject.purchaseTable)){
            nonMatchInfo = beforeAfterTableCompare(beforeObject.purchaseTable, afterObject.purchaseTable, "object");
            dataSubTypeArr.push({data: "purchaseTable", nonMatchInfo: nonMatchInfo});
        }
    }
    const returnObj = {dataValid: dataValid, dataType: dataType, dataSubTypeArr: dataSubTypeArr,
        beforeObj: beforeObject, afterObj: afterObject };

    return returnObj;
}
export default beforeAfterCompare;